.messageBlock {
  position: relative;
  display: flex;
}

.messageContent {
  flex-grow: 10;
}

.errorTitle {
  text-transform: uppercase;
}

.closeButton {
  align-self: center;
  margin-right: 0.5em;
  min-height: 24px;

  &:hover {
    color: var(--darkSilver);
  }
}
